/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC Button Controls
import { NgcButtonModule } from '../controls/button/ngc-button.component';

/**
 * NGC Button Module
 */

export class NgcButtonsModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    exports: [
        NgcButtonModule
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
